import React from 'react';

import { PaddingProps } from '@tink/core/src/components/atoms/Box/Box';
import { MarginProps } from '@tink/core/src/components/atoms/Margins/margins';
import { BANK_ID_IMAGE } from '../../../config';
import { StyledImage, StyledRoundContainer } from './BankIdLogo.styles';

export const BankIdLogo: React.FC<PaddingProps & MarginProps & { size: string }> = ({
  size,
  ...spacingProps
}) => {
  return (
    <StyledRoundContainer size={size} {...spacingProps}>
      <StyledImage src={BANK_ID_IMAGE} alt="" />
    </StyledRoundContainer>
  );
};
